const mqtt = require("mqtt");
import { socketUrl } from './api'
import Event from 'react-eventproxy';
import Common from '../components/common';

export const connectEventName = 'connectEvent';

//顾客队列
export const CustomerQueue = 'CustomerQueue';
//区域管理
export const AreaManage = 'AreaManage';
//区域视图
export const SocketAreaView = 'AreaView';
//排队情况
export const QueueStatistics = 'QueueStatistics';

const eventNames = {
    'CustomerQueue': CustomerQueue,
    'AreaManage': AreaManage,
    'AreaView': SocketAreaView,
    'QueueStatistics': QueueStatistics
}

const CryptoJS = require("crypto-js");
const accessKey = 'LTAIsoJ8rDvp0pZv'
const secretKey = 'NOltNMINUwzNXJLFXZ0SQTo9e5dNX5'

const clientId = 'GID_SoReal@@@web_site_queue_' + new Date().getTime()
const instanceId = 'post-cn-2r42795180j'
const endPort = "post-cn-2r42795180j.mqtt.aliyuncs.com";
const storeId = Common.getStoreInfo()?.storeId 
const topic = 'SoRealControl/' + storeId + '/1';

const username = 'Signature|' + accessKey + '|' + instanceId;
const password = CryptoJS.HmacSHA1(clientId, secretKey).toString(CryptoJS.enc.Base64);

class MqttClient {
    client = null
    connect() {
        var _self = this;
        const options = {
            'username': username,
            'password': password,
            'clientId': clientId,
            'keepalive': 90,
            'reconnectPeriod': 5000
        }
        // console.log(clientId)
        if(!storeId){
            return
        }
        if (_self.client == null ) {
            const _protocol = window.location.protocol == "http:" ? 'ws' : 'wss';
            _self.client = mqtt.connect(_protocol + "://" + endPort, options);
            _self.client.on('connect', function () {
                console.log('mqtt connect success');
                _self.client.subscribe(topic, function (err) {
                    if (!err) {
                    }
                })
            })
            _self.client.on('message', function (topicLink, message) {
                try {
                    if (topicLink == topic) {
                        let serverMsg = JSON.parse(JSON.parse(message));
                        const { event, data, option } = serverMsg;
                        if (eventNames[event]) {
                            Event.trigger(eventNames[event], { data, option });
                        }
                    }
                } catch (error) {
                    self.connect();
                }
            })
        }
    }
    disConnect(){
        if(this.client)
        { 
            this.client.end();
            this.client = null
        }
    }
}
const _mqttClient = new MqttClient();

export default _mqttClient;